import request from '@/utils/request'

// 获取websocket地址 (语音转文字)
export const getVoiceToCharacterUrlApi = (params, config = {}) => request.get('/xunfei/voiceToCharacterUrl', params, config)
// 获取websocket地址 (文字转语音)
export const getCharacterToVoiceUrlApi = params => request.get('/xunfei/characterToVoiceUrl', params)
// 用户说完话传给后端的接口
export const getChatStreamApi = (userId,message) => request.get(`/keyue/ernie/chatStream/${userId}?message=${message}`)
